import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/blank.png';
import _imports_1 from '../assets/imgs/defeated-icon1.png';
import _imports_2 from '../assets/imgs/loading.png';
const _withScopeId = n => (_pushScopeId("data-v-334f5bc5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "details-left-banner"
}, null, -1));
const _hoisted_3 = {
  class: "details-top"
};
const _hoisted_4 = {
  class: "details-top-text2"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "details-left-banner"
}, null, -1));
const _hoisted_6 = {
  class: "details-fotter"
};
const _hoisted_7 = {
  class: "software-details-info"
};
const _hoisted_8 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  style: {
    "margin-left": "25px"
  }
};
const _hoisted_11 = {
  class: "row1-rsoftware-name"
};
const _hoisted_12 = {
  class: "row1-rsoftware-change"
};
const _hoisted_13 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "left",
    "color": "#f24014",
    "font-size": "14px"
  }
}, " 提交下架申请后不可撤销 ", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "left",
    "color": "#f24014",
    "margin-bottom": "12px",
    "font-size": "14px"
  }
}, " 软件下架申请通过后若重新上架需走新增软件流程 ", -1));
const _hoisted_16 = {
  key: 1,
  style: {
    "display": "flex"
  }
};
const _hoisted_17 = {
  class: "software-review-version"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "add-software-text"
}, "审核版本", -1));
const _hoisted_19 = {
  key: 0,
  class: "info-show"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_21 = ["title"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "暂无提交审核版本，点击提交新版本", -1));
const _hoisted_23 = {
  key: 1,
  class: "info-show"
};
const _hoisted_24 = {
  key: 0,
  class: "icon",
  src: _imports_1,
  alt: ""
};
const _hoisted_25 = {
  key: 1,
  class: "icon",
  src: _imports_2,
  alt: ""
};
const _hoisted_26 = ["title"];
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  class: "tdesign-demo-image-viewer__base"
};
const _hoisted_29 = {
  class: "tdesign-demo-image-viewer__ui-image"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  key: 1
};
const _hoisted_32 = {
  class: "software-operation-list"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "add-software-text"
}, "操作记录", -1));
const _hoisted_34 = {
  style: {
    "padding": "10px 30px 10px 55px"
  }
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  key: 1
};
const _hoisted_37 = {
  key: 2
};
const _hoisted_38 = {
  key: 3
};
const _hoisted_39 = {
  key: 4
};
const _hoisted_40 = {
  key: 5,
  style: {
    "color": "#f24014"
  }
};
const _hoisted_41 = {
  key: 6
};
const _hoisted_42 = {
  key: 7
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_breadcrumbItem = _resolveComponent("t-breadcrumbItem");
  const _component_t_breadcrumb = _resolveComponent("t-breadcrumb");
  const _component_t_icon = _resolveComponent("t-icon");
  const _component_t_button = _resolveComponent("t-button");
  const _component_t_dropdown = _resolveComponent("t-dropdown");
  const _component_t_textarea = _resolveComponent("t-textarea");
  const _component_t_dialog = _resolveComponent("t-dialog");
  const _component_Commercial = _resolveComponent("Commercial");
  const _component_BrowseIcon = _resolveComponent("BrowseIcon");
  const _component_t_image_viewer = _resolveComponent("t-image-viewer");
  const _component_t_table = _resolveComponent("t-table");
  const _component_t_content = _resolveComponent("t-content");
  const _component_t_link = _resolveComponent("t-link");
  const _component_t_footer = _resolveComponent("t-footer");
  const _component_t_layout = _resolveComponent("t-layout");
  return _openBlock(), _createBlock(_component_t_layout, {
    style: 'height: 100%'
  }, {
    default: _withCtx(() => [_createVNode(_component_t_content, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_t_breadcrumb, null, {
        default: _withCtx(() => [_createVNode(_component_t_breadcrumbItem, {
          style: {
            "color": "#000"
          },
          onClick: _ctx.goHomepage
        }, {
          default: _withCtx(() => [_createTextVNode("首页")]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_t_breadcrumbItem, {
          disabled: ""
        }, {
          default: _withCtx(() => [_createTextVNode("软件详情")]),
          _: 1
        })]),
        _: 1
      })])]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "details-info-row1",
        style: _normalizeStyle({
          display: !_ctx.softwareContrast ? 'none' : 'flex'
        })
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        class: "row1-software-logo",
        src: _ctx.softwareContrast.software_logo
      }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.softwareContrast.software_name) + " V " + _toDisplayString(_ctx.softwareContrast.versions), 1), _createElementVNode("div", _hoisted_12, [_ctx.softwareContrast.software_state == 3 ? (_openBlock(), _createBlock(_component_t_icon, {
        key: 0,
        name: "check-circle",
        class: "statecard-icon",
        style: {
          "color": "#00be63"
        }
      })) : _createCommentVNode("", true), _ctx.softwareContrast.software_state == 5 || _ctx.softwareContrast.software_state == 7 ? (_openBlock(), _createBlock(_component_t_icon, {
        key: 1,
        name: "error-circle",
        class: "statecard-icon",
        style: {
          "color": "#f24014"
        }
      })) : _createCommentVNode("", true), _createElementVNode("span", {
        style: _normalizeStyle({
          color: _ctx.typeColor[_ctx.softwareContrast.software_state],
          padding: '0px 3px'
        })
      }, _toDisplayString(_ctx.typemap[_ctx.softwareContrast.software_state]), 5)])])]), _ctx.softwareContrast.software_state == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_t_button, {
        class: "software-details-button",
        variant: "outline",
        theme: "primary",
        style: {
          "margin-right": "6px"
        },
        onClick: _ctx.watchDetail
      }, {
        default: _withCtx(() => [_createTextVNode("查看详情 ")]),
        _: 1
      }, 8, ["onClick"]), _ctx.softwareData.software_state != 2 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "card-dropdown",
        onMouseenter: _cache[1] || (_cache[1] = $event => _ctx.flag = true),
        onMouseleave: _cache[2] || (_cache[2] = $event => _ctx.flag = false)
      }, [_createVNode(_component_t_dropdown, {
        options: _ctx.options,
        onClick: _ctx.clickHandler,
        placement: "bottom-right",
        maxColumnWidth: 120
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_t_icon, {
          class: _normalizeClass({
            arrowTransformReturn: !_ctx.flag,
            arrowTransform: _ctx.flag
          }),
          name: "chevron-down",
          style: {
            "height": "100%",
            "width": "25px",
            "color": "#2049ee"
          }
        }, null, 8, ["class"])])]),
        _: 1
      }, 8, ["options", "onClick"]), _createVNode(_component_t_dialog, {
        visible: _ctx.applyVisible,
        header: "申请下架",
        "close-btn": false,
        "on-confirm": _ctx.applyConfirm,
        "on-cancel": _ctx.applyCancel,
        "confirm-btn": {
          content: '取消',
          theme: 'primary',
          variant: 'outline'
        },
        cancelBtn: {
          content: '申请下架',
          theme: 'primary'
        }
      }, {
        default: _withCtx(() => [_hoisted_14, _hoisted_15, _createVNode(_component_t_textarea, {
          placeholder: "请说明申请软件下架的原因",
          modelValue: _ctx.takedownReason,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.takedownReason = $event),
          autosize: {
            minRows: 5,
            maxRows: 5
          },
          style: {
            "resize": "none"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["visible", "on-confirm", "on-cancel"])], 32)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.softwareContrast.software_state == 7 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_t_button, {
        class: "software-details-button",
        variant: "outline",
        theme: "primary",
        style: {
          "margin-right": "6px"
        },
        onClick: _ctx.getdownReason
      }, {
        default: _withCtx(() => [_createTextVNode("查看理由 ")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_t_dialog, {
        visible: _ctx.getdownVisible,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => _ctx.getdownVisible = $event),
        header: "下架原因",
        "confirm-on-enter": false,
        "close-btn": true,
        body: _ctx.softwareContrast.approve_comments,
        "on-confirm": _ctx.onConfirmAnother,
        "confirm-btn": {
          content: '去修改',
          theme: 'primary'
        },
        cancelBtn: null
      }, null, 8, ["visible", "body", "on-confirm"])])) : _createCommentVNode("", true)], 4)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _ctx.softwareContrast.software_id == _ctx.softwareData.software_id ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", {
        class: "name",
        title: _ctx.softwareData.software_name
      }, [_createTextVNode(_toDisplayString(_ctx.softwareData.software_name) + " V " + _toDisplayString(_ctx.softwareData.versions) + " ", 1), _ctx.userCommercial && _ctx.softwareData.commercial ? (_openBlock(), _createBlock(_component_Commercial, {
        key: 0,
        style: {
          "position": "absolute",
          "margin-top": "3px",
          "margin-left": "10px"
        }
      })) : _createCommentVNode("", true)], 8, _hoisted_21), _hoisted_22, _createVNode(_component_t_button, {
        class: "button",
        onClick: _ctx.submitNew,
        disabled: _ctx.softwareData.software_state == 5 || _ctx.softwareData.software_state == 7
      }, {
        default: _withCtx(() => [_createTextVNode("提交新版本")]),
        _: 1
      }, 8, ["onClick", "disabled"])])) : _createCommentVNode("", true), _ctx.softwareContrast.software_id != _ctx.softwareData.software_id ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_ctx.softwareData.software_state == 6 ? (_openBlock(), _createElementBlock("img", _hoisted_24)) : _createCommentVNode("", true), _ctx.softwareData.software_state == 2 || _ctx.softwareData.software_state == 8 || _ctx.softwareData.software_state == 4 || _ctx.softwareData.software_state == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_25)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "name",
        title: _ctx.softwareData.software_name
      }, [_createTextVNode(_toDisplayString(_ctx.softwareData.software_name) + " V " + _toDisplayString(_ctx.softwareData.versions) + " ", 1), _ctx.userCommercial && _ctx.softwareData.commercial ? (_openBlock(), _createBlock(_component_Commercial, {
        key: 0,
        style: {
          "position": "absolute",
          "margin-top": "3px",
          "margin-left": "10px"
        }
      })) : _createCommentVNode("", true)], 8, _hoisted_26), _createElementVNode("div", {
        class: _normalizeClass(['description', {
          'description-warn': _ctx.softwareData.software_state == 4 || _ctx.softwareData.software_state == 6
        }, {
          'description-hint': _ctx.softwareData.software_state == 1 || _ctx.softwareData.software_state == 8 || _ctx.softwareData.software_state == 2
        }])
      }, _toDisplayString(_ctx.stateTxt), 3), _ctx.softwareData.software_state == 6 ? (_openBlock(), _createBlock(_component_t_button, {
        key: 2,
        onClick: _ctx.rejectReason,
        class: "button"
      }, {
        default: _withCtx(() => [_createTextVNode("查看理由")]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_t_dialog, {
        width: "800px",
        visible: _ctx.visible,
        "onUpdate:visible": _cache[6] || (_cache[6] = $event => _ctx.visible = $event),
        header: "驳回原因",
        "confirm-on-enter": false,
        "close-btn": true,
        "on-confirm": _ctx.onConfirmAnother,
        "confirm-btn": {
          content: '去修改',
          theme: 'primary'
        },
        cancelBtn: null
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.softwareData.approve_comments), 1), _createElementVNode("div", null, [_ctx.softwareData.approve_comment_img ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_t_image_viewer, {
          visible: _ctx.imgVisible,
          images: [_ctx.softwareData.approve_comment_img],
          onClose: _ctx.close
        }, {
          trigger: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createElementVNode("img", {
            alt: "test",
            src: _ctx.softwareData.approve_comment_img,
            class: "tdesign-demo-image-viewer__ui-image--img"
          }, null, 8, _hoisted_30), _createElementVNode("div", {
            class: "tdesign-demo-image-viewer__ui-image--hover",
            onClick: _cache[4] || (_cache[4] =
            //@ts-ignore
            (...args) => _ctx.onOpen && _ctx.onOpen(...args))
          }, [_createElementVNode("span", null, [_createVNode(_component_BrowseIcon, {
            size: "1.4em"
          }), _createTextVNode(" 预览")])])])]),
          _: 1
        }, 8, ["visible", "images", "onClose"])])])) : _createCommentVNode("", true), _ctx.softwareData.approve_comment_video ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", {
          style: {
            "color": "#2049ee",
            "font-size": "13px",
            "cursor": "pointer"
          },
          onClick: _cache[5] || (_cache[5] = $event => _ctx.downloadMP4File(_ctx.softwareData.approve_comment_video))
        }, " 点击下载视频附件 ")])) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["visible", "on-confirm"]), _ctx.softwareData.software_state == 2 || _ctx.softwareData.software_state == 8 ? (_openBlock(), _createBlock(_component_t_button, {
        key: 3,
        class: "button",
        variant: "outline",
        theme: "primary",
        onClick: _ctx.undo
      }, {
        default: _withCtx(() => [_createTextVNode("撤销审核")]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_t_dialog, {
        visible: _ctx.visibleSave,
        "close-btn": false,
        header: _ctx.getHeader,
        body: _ctx.getBody,
        "confirm-btn": _ctx.getConfirmBtn,
        "cancel-btn": _ctx.getCancelBtn
      }, null, 8, ["visible", "header", "body", "confirm-btn", "cancel-btn"]), _ctx.softwareData.software_state == 1 ? (_openBlock(), _createBlock(_component_t_button, {
        key: 4,
        class: "button",
        variant: "outline",
        theme: "primary",
        onClick: _ctx.saveDraft
      }, {
        default: _withCtx(() => [_createTextVNode("编辑草稿")]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_createVNode(_component_t_table, {
        data: _ctx.softwareRecordList,
        columns: _ctx.columns,
        "row-key": "property",
        pagination: _ctx.pagination,
        size: 'medium'
      }, {
        software_state: _withCtx(({
          row
        }) => [row.software_state == 1 ? (_openBlock(), _createElementBlock("p", _hoisted_35, "草稿保存中")) : _createCommentVNode("", true), row.software_state == 2 || row.software_state == 8 ? (_openBlock(), _createElementBlock("p", _hoisted_36, " 上架审核中 ")) : _createCommentVNode("", true), row.software_state == 3 ? (_openBlock(), _createElementBlock("p", _hoisted_37, "在架中")) : _createCommentVNode("", true), row.software_state == 4 ? (_openBlock(), _createElementBlock("p", _hoisted_38, "下架审核中")) : _createCommentVNode("", true), row.software_state == 5 ? (_openBlock(), _createElementBlock("p", _hoisted_39, "已下架")) : _createCommentVNode("", true), row.software_state == 6 ? (_openBlock(), _createElementBlock("p", _hoisted_40, " 已驳回 ")) : _createCommentVNode("", true), row.software_state == 7 ? (_openBlock(), _createElementBlock("p", _hoisted_41, "暂时下架中")) : _createCommentVNode("", true), row.software_state == 9 ? (_openBlock(), _createElementBlock("p", _hoisted_42, "已更新")) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data", "columns", "pagination"])])])])]),
      _: 1
    }), _createVNode(_component_t_footer, {
      class: "choose-footer"
    }, {
      default: _withCtx(() => [_createVNode(_component_t_link, {
        style: 'color: #8BA1F7;',
        hover: "color",
        onClick: _ctx.goContactus
      }, {
        default: _withCtx(() => [_createTextVNode("联系我们 ")]),
        _: 1
      }, 8, ["onClick"]), _createTextVNode(" Copyright © 1998 - 2023 Tencent. All Rights Reserved. 腾讯公司 版权所有 ")]),
      _: 1
    })]),
    _: 1
  });
}